import { useRouter } from 'next/router'

export const useGetQuery = (name: string) => {
  const router = useRouter()
  const { asPath } = router
  const query = asPath.split('?')[1]
  if (!query) return ''
  const queryObj = query.split('&').reduce<Map<string, string>>((prev, curr) => {
    const [key, value] = curr.split('=')
    prev.set(key, value)
    return prev
  }, new Map())

  return queryObj.get(name) ?? ''
}
